import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { request } from "@/js/http/http_request";
import { getIdUserFromToken, hasRole } from "@/js/http/auth";
import { listUserGroups, WineRangeAccessibilityEnum, COUNTRIES } from "@/js/lists.ts";
export var CATEGORY_USER = "category_user";
export function getFullNameUser(user) {
  var withCompany = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var hasCompanyName = !!user.company_name;
  var hasContactData = !!user.name || !!user.nickname;
  if (user.user_group && (user.user_group === "HORECA" || user.user_group === "WHOLESALER" || user.isHolding)) {
    if (hasCompanyName && hasContactData) return withCompany ? user.company_name + ", " + user.name + " " + user.nickname : user.name + " " + user.nickname;else if (hasCompanyName && !hasContactData) return user.company_name;else if (!hasCompanyName && hasContactData) return user.name + " " + user.nickname;else return user.login;
  } else {
    if (hasCompanyName && hasContactData) return withCompany ? user.name + " " + user.nickname + ", " + user.company_name : user.name + " " + user.nickname;else if (hasCompanyName && !hasContactData) return user.company_name;else if (!hasCompanyName && hasContactData) return user.name + " " + user.nickname;else return user.login;
  }
}
export function getFullNameUserHtml(user) {
  var withCompany = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var withGroup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var html = "";
  if (!withCompany) {
    html = user.name + " " + user.nickname;
  } else if (user.user_group && (user.user_group === "HORECA" || user.user_group === "WHOLESALER" || user.isHolding)) {
    var _user$company_name;
    html = ((_user$company_name = user.company_name) !== null && _user$company_name !== void 0 ? _user$company_name : "") + (user.name || user.nickname ? "<br>" + user.name + " " + user.nickname : "");
  } else {
    html = user.name + " " + user.nickname + (user.company_name ? "<br>" + user.company_name : "");
  }
  if (withGroup) {
    html += "<br>" + userGroupName(user);
  }
  return html;
}
export function userHasByPassLimit(id) {
  return request("/v1/user/" + id, "get", null, true, "api").then(function (response) {
    return response.data.has_bypass_buy_limit;
  }).catch(function (e) {
    return e;
  });
}
export function userGroupName(user) {
  if ((user === null || user === void 0 ? void 0 : user.user_group) === "ADMIN" && user !== null && user !== void 0 && user.isHolding) {
    return "Corporate";
  } else {
    var _listUserGroups$find$, _listUserGroups$find;
    return (_listUserGroups$find$ = (_listUserGroups$find = listUserGroups.find(function (x) {
      return x.id == (user === null || user === void 0 ? void 0 : user.user_group);
    })) === null || _listUserGroups$find === void 0 ? void 0 : _listUserGroups$find.name) !== null && _listUserGroups$find$ !== void 0 ? _listUserGroups$find$ : "";
  }
}
export function userIsIndividual(user) {
  return (user === null || user === void 0 ? void 0 : user.user_group) === "USER";
}
export function userIsProfessional(user) {
  return (user === null || user === void 0 ? void 0 : user.user_group) === "HORECA";
}
export function userIsWholesaler(user) {
  return (user === null || user === void 0 ? void 0 : user.user_group) === "WHOLESALER";
}
export function userIsHolding(user) {
  return user === null || user === void 0 ? void 0 : user.isHolding;
}
export function userIsConsultantNotHolding(user) {
  var _user$consultant_code;
  debugger;
  return (user === null || user === void 0 ? void 0 : user.user_group) === "ADMIN" && (user === null || user === void 0 || (_user$consultant_code = user.consultant_code) === null || _user$consultant_code === void 0 ? void 0 : _user$consultant_code.length) > 0 && !(user !== null && user !== void 0 && user.isHolding);
}
export function transformAsCustomerIfConsultantNotHolding(user) {
  //copied from api.userDto.TransformAsCustomerIfConsultantNotHolding();
  if (userIsConsultantNotHolding(user)) {
    var _user$company_name2;
    if ((user === null || user === void 0 || (_user$company_name2 = user.company_name) === null || _user$company_name2 === void 0 ? void 0 : _user$company_name2.length) > 0) {
      user.user_group = "HORECA";
    } else {
      user.user_group = "USER";
      user.vat_code = "";
    }
    user.user_sub_group = "";
    user.consultant_code = "";
    user.sponsorship_code = "";
    user.consultantAttached = null;
    user.salesman_follower = null;
  }
  return user;
}
export function userIsHorecaUs(user) {
  if (!userIsProfessional(user)) {
    return false;
  } else {
    var _user$delivery_addres;
    return (user === null || user === void 0 || (_user$delivery_addres = user.delivery_address) === null || _user$delivery_addres === void 0 || (_user$delivery_addres = _user$delivery_addres.country) === null || _user$delivery_addres === void 0 ? void 0 : _user$delivery_addres.iso_code) === "USA";
  }
}
export function fetchCategoryUser() {
  return _fetchCategoryUser.apply(this, arguments);
}
function _fetchCategoryUser() {
  _fetchCategoryUser = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var userId,
      orderId,
      thirdPartyOrder,
      url,
      response,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          userId = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
          orderId = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
          thirdPartyOrder = hasRole(process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER);
          if (!(userId || !thirdPartyOrder)) {
            _context.next = 15;
            break;
          }
          if (!userId) {
            userId = getIdUserFromToken();
          }
          url = "/v1/category-users/".concat(userId);
          if (orderId) {
            url += "?orderId=".concat(orderId);
          }
          _context.next = 9;
          return request(url, "get", null, true, "api", null).catch(function (_) {
            return null;
          });
        case 9:
          response = _context.sent;
          if (!response) {
            _context.next = 13;
            break;
          }
          setCategoryUser(response.data.value);
          return _context.abrupt("return", response.data.value);
        case 13:
          _context.next = 16;
          break;
        case 15:
          removeCategoryUserFromStorage();
        case 16:
          return _context.abrupt("return", null);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchCategoryUser.apply(this, arguments);
}
export function setCategoryUser(categoryUser) {
  localStorage.setItem(CATEGORY_USER, JSON.stringify(categoryUser));
}
export function getCategoryUser() {
  var categoryUser = localStorage.getItem(CATEGORY_USER);
  if (categoryUser) {
    return JSON.parse(categoryUser);
  }
  return null;
}
export function removeCategoryUserFromStorage() {
  localStorage.removeItem(CATEGORY_USER);
}
export function hasAccessGranted(wineRangeAccessibility) {
  if (!wineRangeAccessibility || wineRangeAccessibility === WineRangeAccessibilityEnum.CORE_ITEM) {
    return true;
  }
  var categoryUser = getCategoryUser();
  return !categoryUser || (categoryUser === null || categoryUser === void 0 ? void 0 : categoryUser.rangeAccessibility) >= wineRangeAccessibility;
}
export var COUNTRY_SPECIAL_WORDINGS = {
  BRAZIL: {
    countryId: COUNTRIES.BRAZIL.id,
    liquorNumberLabel: "Inscriçao Estadual",
    taxIdLabel: "CNPJ",
    individualCodeLabel: "CPF"
  }
};